import { cva, type VariantProps } from "class-variance-authority";
import * as React from "react";
import { cn } from "@/core/utils/utils";

const stackVariants = cva("flex", {
  variants: {
    direction: {
      row: "flex-row",
      column: "flex-col",
    },
    gap: {
      none: "gap-0",
      xs: "gap-1", // 4px
      sm: "gap-2", // 8px
      md: "gap-4", // 16px
      lg: "gap-6", // 24px
      xl: "gap-8", // 32px
    },
    justify: {
      start: "justify-start",
      end: "justify-end",
      center: "justify-center",
      between: "justify-between",
      around: "justify-around",
      evenly: "justify-evenly",
    },
    align: {
      start: "items-start",
      end: "items-end",
      center: "items-center",
      baseline: "items-baseline",
      stretch: "items-stretch",
    },
    fullWidth: {
      true: "w-full",
    },
  },
  defaultVariants: {
    direction: "column",
    gap: "md",
    justify: "start",
    align: "start",
    fullWidth: false,
  },
});

export interface StackProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof stackVariants> {}

const Stack = React.forwardRef<HTMLDivElement, StackProps>(
  ({ className, direction, gap, justify, align, fullWidth, ...props }, ref) => (
    <div
      ref={ref}
      className={cn(
        stackVariants({
          direction,
          gap,
          justify,
          align,
          fullWidth,
          className,
        }),
      )}
      {...props}
    />
  ),
);
Stack.displayName = "Stack";

export { Stack, stackVariants };
